"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastCorrelationId = exports.setLastCorrelationId = void 0;
/** Last backend correlation id from an API response header (x-request-id). */
let lastCorrelationId;
const setLastCorrelationId = (correlationId) => {
    lastCorrelationId = correlationId;
};
exports.setLastCorrelationId = setLastCorrelationId;
const getLastCorrelationId = () => lastCorrelationId;
exports.getLastCorrelationId = getLastCorrelationId;
//# sourceMappingURL=lastCorrelationId.js.map